import React from 'react';
import PropTypes from 'prop-types';
import { CmsEntities } from 'client/data/models/cms';
import { getValidImageUrl, SOURCES } from 'client/utils/image-helpers';
import { Link } from 'site-modules/shared/components/link/link';
import { Share } from 'site-modules/shared/components/share/share';

const PHOTO_CONSTRAINT = { maxWidth: '80px' };

export function ByLine({ authorEntry, title, canonical }) {
  const authorName = authorEntry.metadata('authorName').value();
  const authorLink = authorEntry.metadata('authorLink').value();
  const authorPhoto = authorEntry.metadata('photoPath').value();

  return (
    <div className="by-line d-flex flex-column flex-md-row justify-content-between align-items-md-end">
      {authorName && (
        <div className="d-flex align-items-end text-gray-darker mb-1 mb-md-0">
          {authorPhoto && (
            <img
              style={PHOTO_CONSTRAINT}
              className="photo rounded me-0_5"
              src={getValidImageUrl(authorPhoto, SOURCES.STATIC)}
              aria-hidden="true"
              alt=""
            />
          )}
          by&nbsp;
          <Link to={authorLink} className="fw-bold">
            {authorName}
          </Link>
        </div>
      )}
      <Share
        url={canonical}
        title={title}
        labelClassName="pe-0_5 align-middle"
        containerClassName="col-auto d-block card ps-1_25 py-0_75 mb-0"
        iconClassName="heading-4 mx-1_25 p-0"
      />
    </div>
  );
}

ByLine.propTypes = {
  authorEntry: CmsEntities.Content.isRequired,
  title: PropTypes.string.isRequired,
  canonical: PropTypes.string.isRequired,
};
